import React, { Component } from 'react';

export default class PrivacyPolicyContent extends Component {
    render() {
        const { t } = this.props;
        return (
            <div className="container">
                <div className="row">
                    <div className="mgt-30 faq-container">
                        <div className="text-left">
                            <h2 className="common-title">{t('privacy_title')}</h2>
                            <h4 className="common-title">
                                {t('privacy_subtitle_1')}
                                <br />
                                {t('privacy_subtitle_2')}
                            </h4>
                        </div>
                        <hr />
                        <div className="faq-content">
                            <div className="list-policy">
                                <div className="list-policy-item row">
                                    <ul className="list-policy-sidenav col-12 col-md-12">
                                        <li>
                                            <h4><b>{t('article_1')}</b></h4>
                                            {t('article_1_content')}
                                        </li>
                                        <hr/>
                                        <li>
                                            <h4><b>{t('article_2')}</b></h4>
                                            {t('article_2_content')}
                                        </li>
                                        <hr/>
                                        <li>
                                            <h4><b>{t('article_3')}</b></h4>
                                            {t('article_3_content')}
                                        </li>
                                        <hr />
                                        <li>
                                            <h4><b>{t('article_4')}</b></h4>
                                            <p>{t('article_4_p_1')}</p>
                                            <p>{t('article_4_p_2')}</p>
                                            <ul>
                                                <li><b>・ </b>{t('article_4_p_2_li_1')}</li>
                                                <li><b>・ </b>{t('article_4_p_2_li_2')}</li>
                                                <li><b>・ </b>{t('article_4_p_2_li_3')}</li>
                                                <li><b>・ </b>{t('article_4_p_2_li_4')}</li>
                                                <li><b>・ </b>{t('article_4_p_2_li_5')}</li>
                                                <li><b>・ </b>{t('article_4_p_2_li_6')}</li>
                                                <li><b>・ </b>{t('article_4_p_2_li_7')}</li>
                                                <li><b>・ </b>{t('article_4_p_2_li_8')}</li>
                                                <li><b>・ </b>{t('article_4_p_2_li_9')}</li>
                                                <li><b>・ </b>{t('article_4_p_2_li_10')}</li>
                                            </ul>
                                        </li>
                                        <hr />
                                        <li>
                                            <h4><b>{t('article_5')}</b></h4>
                                            <p>{t('article_5_p_1')}</p>
                                            <p>{t('article_5_p_2')}</p>
                                            <ul>
                                                <li><b>・ </b>{t('article_5_p_2_li_1')}</li>
                                                <li><b>・ </b>{t('article_5_p_2_li_2')}</li>
                                                <li><b>・ </b>{t('article_5_p_2_li_3')}</li>
                                                <li><b>・ </b>{t('article_5_p_2_li_4')}</li>
                                                <li><b>・ </b>{t('article_5_p_2_li_5')}</li>
                                                <li><b>・ </b>{t('article_5_p_2_li_6')}</li>
                                                <li><b>・ </b>{t('article_5_p_2_li_7')}</li>
                                                <li><b>・ </b>{t('article_5_p_2_li_8')}</li>
                                            </ul>
                                            <p>{t('article_5_p_3')}</p>
                                            <ul>
                                                <li><b>・ </b>{t('article_5_p_3_li_1')}</li>
                                            </ul>
                                            <p>{t('article_5_p_4')}</p>
                                            <ul>
                                                <li><b>・ </b>{t('article_5_p_4_li_1')}</li>
                                            </ul>
                                        </li>
                                        <hr />
                                        <li>
                                            <h4><b>{t('article_6')}</b></h4>
                                            <p>{t('article_6_p_1')}</p>
                                            <ul>
                                                <li><b>・ </b>{t('article_6_p_1_li_1')}</li>
                                                <li><b>・ </b>{t('article_6_p_1_li_2')}</li>
                                                <li><b>・ </b>{t('article_6_p_1_li_3')}</li>
                                            </ul>
                                            <p>{t('article_6_p_2')}</p>
                                        </li>
                                        <hr />
                                        <li>
                                            <h4><b>{t('article_7')}</b></h4>
                                            <p>{t('article_7_p_1')}</p>
                                            <p>{t('article_7_p_2')}</p>
                                        </li>
                                        <hr />
                                        <li>
                                            <h4><b>{t('article_8')}</b></h4>
                                            <p>{t('article_8_p_1')}</p>
                                        </li>
                                        <hr />
                                        <li>
                                            <h4><b>{t('article_9')}</b></h4>
                                            <p>{t('article_9_p_1')}</p>
                                            <ul>
                                                <li><b>・ </b>{t('article_9_p_1_li_1')}</li>
                                                <li><b>・ </b>{t('article_9_p_1_li_2')}</li>
                                            </ul>
                                        </li>
                                        <hr />
                                        <li>
                                            <h4><b>{t('article_10')}</b></h4>
                                            <p>{t('article_10_p_1')}</p>
                                            <p>{t('article_10_p_2')}</p>
                                        </li>
                                        <hr />
                                        <li>
                                            <h4><b>{t('article_11')}</b></h4>
                                            <p>{t('article_11_p_1')}</p>
                                            <p>{t('article_11_p_2')}</p>
                                        </li>
                                        <hr />
                                        <li>
                                            <h4><b>{t('article_12')}</b></h4>
                                            <p>{t('article_12_p_1')}</p>
                                        </li>
                                        <hr />
                                        <li>
                                            <table>
                                                <tr>
                                                    <td><b>{t('address_')}:</b></td>
                                                    <td style={{ paddingLeft: 10 }}>Room 705,7th Floor, Nam Wo Hong Building, 148 Wing Lok Street, Sheung Wan, Hong Kong</td>
                                                </tr>
                                                <tr>
                                                    <td><b>{t('company_name')}:</b></td>
                                                    <td style={{ paddingLeft: 10 }}>EXCEL FINANCE LIMITED</td>
                                                </tr>
                                                <tr>
                                                    <td><b>{t('email_address')}:</b></td>
                                                    <td style={{ paddingLeft: 10 }}>info@excelfinance-ltd.com</td>
                                                </tr>
                                            </table>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/privacyPolicyContent.jsx